// eslint-disable-next-line
import React from 'react';
import { List } from '@material-ui/core';
import { NavigationType } from '@nal/navigation';
import NavigationItem from './NavigationItem/NavigationItem';

type NavigationPropType = {
    navigations: NavigationType[];
    open: boolean;
};

const Navigation: React.FC<NavigationPropType> = ({ navigations, open }) => {
    return (
        <List>
            {navigations && navigations.map((item) => <NavigationItem open={open} item={item} key={item.id} />)}
        </List>
    );
};

export default Navigation;
